import { Link } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

export function PublicMetricLink({ metric, children }) {
    const to = metric?.url || `/stocks/${String(metric?.ticker || '').toLowerCase()}/metrics/${metric?.metric_slug}`;
    return (
        <Link as={RouterLink} to={to} color="blue.600" fontWeight="semibold">
            {children || metric?.display_name}
        </Link>
    );
}
